// extracted by mini-css-extract-plugin
module.exports = {"shadow":"DiscountSection_shadow__YYGGZ","leftCol":"DiscountSection_leftCol__BiAGg","rightCol":"DiscountSection_rightCol__8px9P"};